<!-- eslint-disable max-len -->
<template>
  <div class="mx-auto min-h-full">
    <SimpleHeader
      :on-close="handleClose"
      :pages="[
        { name: t('sidemenu.navigation.affiliate-panel.title'), href: router.resolve({ name: 'AffiliateDashboardPage' }).href, current: true },
      ]"
    />
    <RouterView
      v-if="dataLoaded"
      :user="user"
    />
  </div>
  <SimpleFooter
    :horizontal="true"
  />
</template>

<script setup lang="ts">
import {
  ref,
  onBeforeMount,
  onMounted,
} from 'vue';
import { useRouter } from 'vue-router';
import useUserStore from '@/store/user';
import User from '@/models/user';
// import useAuthStore from '@/store/auth';
import { useI18n } from 'vue-i18n';
import SimpleHeader from '@/components/tailwind/header/SimpleHeader.vue';
import SimpleFooter from '@/components/tailwind/footer/SimpleFooter.vue';

const router = useRouter();
const { t } = useI18n();
const {
  usersDoGetMyUser,
} = useUserStore();

const handleClose = () => {
  router.push({
    name: 'DashboardPage',
  });
};

/*
  Data
*/
const dataLoaded = ref(false);
const isLoading = ref(true);
const user = ref<User>();

/*
  Methods
*/
const loadCurrentUser = async () => {
  isLoading.value = true;
  await usersDoGetMyUser().then((response) => {
    if (!response) {
      throw new Error('User not found');
    }
    user.value = response;
    isLoading.value = false;
    dataLoaded.value = true;
  }).catch((error) => {
    alert('Erro ao carregar usuário');
    router.push({
      name: 'DashboardPage',
    });
  });
};

/*
  Hooks
*/
onBeforeMount(async () => {
  await loadCurrentUser();
});
onMounted(() => {
  setTimeout(() => {
    dataLoaded.value = true;
  }, 500);
});
</script>
